import { render } from "./LastPipelineRunsPanel.vue?vue&type=template&id=08a80e22&scoped=true&ts=true"
import script from "./LastPipelineRunsPanel.vue?vue&type=script&lang=ts"
export * from "./LastPipelineRunsPanel.vue?vue&type=script&lang=ts"

import "./LastPipelineRunsPanel.vue?vue&type=style&index=0&id=08a80e22&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a80e22"]])

export default __exports__